// Lectores de saldo, puros y sin dependencias. Viven en su propio modulo porque
// clientBalances.js y providerBalances.js importan `../supabase`, que abre el
// cliente al importarse y revienta fuera del browser: cualquier logica que use
// estos getters quedaba imposible de testear con `node --test`.
//
// clientBalances.js y providerBalances.js los re-exportan, asi que todo lo que
// ya los importaba de ahi sigue funcionando igual.

import { isGenericConsumidorFinalClient } from "./consumidorFinal.js";

// NOTA: la tabla clients de esta DB no tiene current_balance; el fallback a
// `balance` es el que termina usandose en la practica.
export const getClientBalanceValue = (client) =>
  Number(client?.current_balance ?? client?.balance ?? 0);

export const getProviderBalanceValue = (provider) => Number(provider?.saldo || 0);

// Lo COBRABLE de un cliente, que no es lo mismo que su columna de saldo.
//
// El consumidor final generico (venta de mostrador) es contado por definicion:
// el resto del sistema ya lo trata asi — clientBalances.js lo saltea al armar
// la cuenta corriente y paymentTerms.js nunca lo deja pendiente de cobro. Pero
// la columna `balance` igual acumula, y quien la lea cruda ve una deuda que no
// existe: medido el 17/09/2026 en produccion, el cliente "CONSUMIDOR FINAL" de
// dos organizaciones arrastraba $109.240.624 y $203.818.747.
//
// Esta funcion expresa la regla una sola vez para que ningun reporte la olvide.
export const getClientReceivableValue = (client) =>
  isGenericConsumidorFinalClient(client) ? 0 : getClientBalanceValue(client);
